// const SUITABILITY_SCORE_LOW = 25;

export default class CustomContextPad {
  constructor(
    bpmnFactory,
    config,
    contextPad,
    create,
    elementFactory,
    injector,
    translate,
  ) {
    this.bpmnFactory = bpmnFactory;
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;

    if (config.autoPlace !== false) {
      this.autoPlace = injector.get("autoPlace", false);
    }

    contextPad.registerProvider(this);
  }

  // eslint-disable-next-line no-unused-vars
  getContextPadEntries(element) {
    // const {
    //   /*autoPlace, */ bpmnFactory,
    //   create,
    //   elementFactory,
    //   translate,
    // } = this;

    // function createTask() {
    //   return function(event) {
    //     const businessObject = bpmnFactory.create("bpmn:ServiceTask");

    //     businessObject.custom_type = "AutomatonCall";

    //     const shape = elementFactory.createShape({
    //       type: "bpmn:ServiceTask",
    //       businessObject: businessObject,
    //     });

    //     create.start(event, shape);
    //   };
    // }

    // return {
    //   "create.low-task": {
    //     group: "activity",
    //     className: "bpmn-icon-service-task red",
    //     title: translate("Automate task"),
    //     action: {
    //       dragstart: createTask(),
    //       click: createTask(),
    //     },
    //   },
    // };
  }
}

CustomContextPad.$inject = [
  "bpmnFactory",
  "config",
  "contextPad",
  "create",
  "elementFactory",
  "injector",
  "translate",
];
